<template>
  <div class="row">
    <div class="col-12">
      <page-header :page="page" />
      <custom-callout
        border-color-hex="#FB7058"
        class="mb-4"
        :has-toggle="false"
      >
        <icon-view
          class="mt-2"
          icon="fa fa-file-invoice-dollar mb-1"
          icon-background="#ff745c"
          icon-color="#fff"
          icon-size="14px"
          title="Informe de Progreso"
        />
        <validation-observer ref="budgetManagementRef" novalidate tag="form">
          <div class="row mt-3 mr-3">
            <div class="col-md-4 col-sm-12 mt-3 mt-md-0">
              <div class="color-gray-6 font-14 mb-1">Mes para Validar:</div>
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-drop-down
                  id="ddlAcademicYear"
                  v-model="progressInform.month"
                  :clearable="false"
                  custom-error-msg="El año académico es requerido."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="options.months"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>
            <div class="col-md-4 col-sm-12 mt-3 mt-md-0">
              <div class="color-gray-6 font-14 mb-1">Activar:</div>
              <validation-provider
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'La cantidad es requerida.',
                  greaterThanZero: 'La cantidad debe ser mayor que 0.',
                }"
                rules="required|greaterThanZero"
              >
                <check-box
                  v-model="progressInform.isActive"
                  class="w-auto color-green underline font-15"
                  :error="errors"
                  text="Activo"
                />
              </validation-provider>
            </div>
            <div
              class="col-md-4 mt-3 d-flex justify-content-end align-items-start"
            >
              <action-button
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger m-2 px-4"
                @click="onCancelHandler"
              />
              <action-button
                i="fas fa-save"
                text="Guardar"
                variant="success m-md-2 px-4"
                @click="onSaveHandler"
              />
            </div>
            <div class="col-md-12 m-3" />
          </div>
        </validation-observer>
      </custom-callout>

      <custom-callout
        border-color-hex="#FB7058"
        class="mb-4"
        :has-toggle="false"
      >
        <icon-view
          class="mt-2"
          icon="fa fa-file-invoice-dollar mb-1"
          icon-background="#ff745c"
          icon-color="#fff"
          icon-size="14px"
          title="Actualizar Visitas basado en Factura (This list of Bills)"
        />
        <validation-observer ref="budgetManagementRef" novalidate tag="form">
          <div class="row mt-3 mr-3">
            <div class="col-md-2 col-sm-12 mt-3 mt-md-0">
              <div class="color-gray-6 font-14 mb-1">Tipo de Actualización</div>
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-drop-down
                  id="ddlAcademicYear"
                  v-model="summary.typeUpdate"
                  :clearable="false"
                  custom-error-msg="El tipo de Actualización es Requerido."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="options.updateTypes"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>
            <div class="col-md-2 col-sm-12 mt-3 mt-md-0">
              <div class="color-gray-6 font-14 mb-1">
                {{ this.summary.typeUpdate?.name }}:
              </div>
              <validation-provider
                v-slot="{ errors }"
                :custom-messages="{
                  required:
                    'Se requiere el Número de Factura o Número de Contrato.',
                }"
                rules="required|greaterThanZero"
              >
                <custom-input
                  v-model="summary.billIdOrContractNumber"
                  :error="errors[0]"
                />
              </validation-provider>
            </div>
            <div class="col-md-2 col-sm-12 mt-3 mt-md-0">
              <div class="color-gray-6 font-14 mb-1">Mes para Validar:</div>
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-drop-down
                  id="ddlAcademicYear"
                  v-model="summary.month"
                  :clearable="false"
                  custom-error-msg="El año académico es requerido."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="options.months"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>
            <div
              class="col-md-6 mt-3 d-flex justify-content-end align-items-start"
            >
              <action-button
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger m-2 px-4"
                @click="onCancelHandler"
              />
              <action-button
                i="fas fa-save"
                text="Actualizar Summary"
                variant="success m-md-2 px-4"
                @click="onUpdateSummary"
              />
            </div>
          </div>
        </validation-observer>
        <div>
          {{ this.summary.result }}
        </div>
      </custom-callout>

      <custom-callout
        border-color-hex="#FB7058"
        class="mb-4"
        :has-toggle="false"
      >
        <icon-view
          class="mt-2"
          icon="fas fa-calendar-edit mb-1"
          icon-background="#ff745c"
          icon-color="#fff"
          icon-size="14px"
          title="Parámetros"
        />
        <sys-parameters />
      </custom-callout>
    </div>
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import CheckBox from 'CheckBox';
import moment from 'moment';
import { updateSummarieByBill as _updateSummariesByBill } from '@/services/support/support.api.js';
import SysParameters from './components/SysParameters.vue';
export default {
  name: 'Settings',
  mixins: [alertMixin],
  components: {
    PageHeader,
    ValidationObserver,
    ValidationProvider,
    CustomCallout,
    ActionButton,
    IconView,
    CustomInput,
    CheckBox,
    CustomDropDown,
    SysParameters,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-cog',
        title: 'Soporte',
        routes: ['Inicio', 'Soporte', 'Funcionalidades'],
      },
      //Models of Features
      progressInform: {
        month: undefined,
        isActive: true,
      },
      summary: {
        typeUpdate: undefined,
        billIdOrContractNumber: undefined,
        month: undefined,
        result: undefined,
      },
      model: {
        month: undefined,
      },
      //Collections of Options
      options: {
        months: moment.months(),
        updateTypes: [
          {
            id: 1,
            name: 'Número de Contrato',
          },
          {
            id: 2,
            name: 'Id de Factura',
          },
        ],
      },
    };
  },
  methods: {
    async onUpdateSummary() {
      const updateSummary = {
        typeUpdate: this.summary.typeUpdate.id,
        billId:
          this.summary.typeUpdate.id == 2
            ? this.summary.billIdOrContractNumber
            : null,
        contractNumber:
          this.summary.typeUpdate.id == 1
            ? this.summary.billIdOrContractNumber
            : null,
        month:
          this.summary.typeUpdate.id == 1
            ? moment()
                .month(this.summary.month)
                .format('M')
            : null,
      };
      this.summary.result = (await _updateSummariesByBill(updateSummary)).data;
    },
  },
};
</script>
